/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RouteLocationOutput,
    RouteLocationOutputFromJSON,
    RouteLocationOutputFromJSONTyped,
    RouteLocationOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface CriteriaForRouteOutput
 */
export interface CriteriaForRouteOutput {
    /**
     * 
     * @type {RouteLocationOutput}
     * @memberof CriteriaForRouteOutput
     */
    to?: RouteLocationOutput;
    /**
     * 
     * @type {RouteLocationOutput}
     * @memberof CriteriaForRouteOutput
     */
    from?: RouteLocationOutput;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteOutput
     */
    isOutbound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForRouteOutput
     */
    match?: boolean;
}

export function CriteriaForRouteOutputFromJSON(json: any): CriteriaForRouteOutput {
    return CriteriaForRouteOutputFromJSONTyped(json, false);
}

export function CriteriaForRouteOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForRouteOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'to': !exists(json, 'to') ? undefined : RouteLocationOutputFromJSON(json['to']),
        'from': !exists(json, 'from') ? undefined : RouteLocationOutputFromJSON(json['from']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isOutbound': !exists(json, 'isOutbound') ? undefined : json['isOutbound'],
        'match': !exists(json, 'match') ? undefined : json['match'],
    };
}

export function CriteriaForRouteOutputToJSON(value?: CriteriaForRouteOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to': RouteLocationOutputToJSON(value.to),
        'from': RouteLocationOutputToJSON(value.from),
        'exclude': value.exclude,
        'isOutbound': value.isOutbound,
        'match': value.match,
    };
}


